import { useFormContext } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';

import { RecurrenceScheduleType, RecurrenceType } from 'models';

import DatetimePicker from 'app/gizmos/fields/datetimes/DatetimePicker';
import DurationCounters from 'app/gizmos/fields/counters/DurationCounters';
import RecurrenceTypeToggle from 'app/gizmos/recurrence/RecurrenceTypeToggle';
import RecurrenceScheduleTypeToggle from 'app/gizmos/recurrence/RecurrenceScheduleTypeToggle';

import MonthlySchedule from './MonthlySchedule';
import YearlySchedule from './YearlySchedule';
import WeeklySchedule from './WeeklySchedule';
import RecurrenceTimeOfDay from './RecurrenceTimeOfDay';
import RecurrenceProjection from './RecurrenceProjection';
import OnDemandRecurrenceTypeToggle from './OnDemandRecurrenceTypeToggle';
import SingleCheckboxGizmo from '../fields/text/SingleCheckboxGizmo';


const RecurrenceGizmo = () =>
{
	const form_context = useFormContext();
	
	const recurrence_type = form_context.watch('recurrence.recurrence_type');
	const schedule_type = form_context.watch('recurrence.recurrence_schedule');
	
	// console.log(form_context.getValues());
	
	
	return (
		<Stack
			gap={2}
		>
			
			<RecurrenceScheduleTypeToggle />
			
			{
				(schedule_type === RecurrenceScheduleType.ON_DEMAND)
				?
				<OnDemandRecurrenceTypeToggle />
				:
				<RecurrenceTypeToggle />
			}
			
			
			<Typography
				variant='body1'
				sx={{
					textAlign: 'center',
				}}
			>
				You can select the trigger threshold from Component Records after the template has been created.
			</Typography>
			
			
			{
				(recurrence_type === RecurrenceType.SCHEDULE)
				&&
				(schedule_type === RecurrenceScheduleType.WEEKLY)
				&&
				<WeeklySchedule />
			}
			
			{
				(recurrence_type === RecurrenceType.SCHEDULE)
				&&
				(schedule_type === RecurrenceScheduleType.MONTHLY)
				&&
				<MonthlySchedule />
			}
			
			{
				(recurrence_type === RecurrenceType.SCHEDULE)
				&&
				(schedule_type === RecurrenceScheduleType.YEARLY)
				&&
				<YearlySchedule />
			}
			
			
			
			{
				(recurrence_type === RecurrenceType.INTERVAL)
				&&
				<DurationCounters
					name='recurrence.interval'
					label='Create Work Order Every…'
				/>
			}
			
			
			{
				(schedule_type !== RecurrenceScheduleType.ON_DEMAND)
				&&
				<>
					<RecurrenceTimeOfDay
						name='recurrence.time_of_day'
						label='Time of Day'
						help='Generated work orders will be due at this time'
					/>
					
					<DatetimePicker
						name='recurrence.effective_datetime'
						label={(recurrence_type === RecurrenceType.INTERVAL)
							? 'Start Generating From'
							: 'Effective Date/Time for Template'
						}
						help={(recurrence_type === RecurrenceType.INTERVAL)
							? 'Delay work order generation and calculate relative dates from this date/time'
							: 'Delay work order generation from this date/time'
						}
					/>
					
					
					{
						(recurrence_type === RecurrenceType.INTERVAL)
						&&
						<SingleCheckboxGizmo
							name='recurrence.skip_first'
							label='Skip First Instance'
							option_label='Skip first instance'
							help={
								(form_context.watch('recurrence.skip_first'))
									? `Won't generate the first instance`
									: 'Will generate the first instance'
							}
						/>
					}
					
					
					<DurationCounters
						name='recurrence.lead_time'
						label='Generation Lead Time'
						help='The amount of time before a work order that a notification or trigger should be generated'
					/>
					
					<RecurrenceProjection />
				</>
			}
			
			
		</Stack>
	)
}


export default RecurrenceGizmo;